import axios from "axios";
// import store from "@/store";
import Router from "@/router";
import storeHelper from '@/store/helper';

const TOKEN_KEY = 'token';

const instance = axios.create({
  // baseURL: API_URL,
  // method: "get",
  timeout: 60000,
  responseEncoding: "utf8",
  headers: {
    "mnp-web-client-version": "1.1.1",
    "accept": "application/json"
  },
});

instance.defaults.headers.post["Content-Type"] = "application/json";
// instance.defaults.withCredentials = true;

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token.replace('Bearer ', '')}`;
    }
    // store.dispatch("loading/set", true);
    return config;
  },
  (error) => {
    // store.dispatch("loading/set", false);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // store.dispatch("loading/set", false);
    return response;
  },
  (error) => {
    if ([401, 403].includes(error.response?.status)) {
      // DelToken();
      // DelRefreshToken();
      // ClearStore();
      Router.history.push({
        path: "/login",
        query: {
          redirect: Router.history.current.path,
        },
      });
    }
    // store.dispatch("loading/set", false);
    return Promise.reject(error);
  }
);

export const getUrl = (key, params = {}) => {
  let url = storeHelper.getUrl(key);

  if (!url) {
    console.log(`URL not found: ${key}`);
    new Error(`URL not found: ${key}`);
  }

  if (url && params && Object.keys(params).length) {
    for (const param in params) {
      url = url.replace(`{${param}}`, params[param]);
    }
  }
  return url;
}

export const Get = async (url, params = {}, option) => {
  const results = await instance.get(url, { params }, option);
  return results.data;
};

export const Post = async (url, params = {}, option) => {
  const results = await instance.post(url, params, option);
  return results.data;
};

export const Put = async (url, params = {}, option) => {
  const results = await instance.put(url, params, option);
  return results.data;
};

export const Patch = async (url, params = {}, option) => {
  const results = await instance.patch(url, params, option);
  return results.data;
};

export const Delete = async (url, option) => {
  const results = await instance.delete(url, option);
  return results.data;
};

export const Upload = async (url, formData, onUploadProgress) => {
  const results = await instance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      typeof onUploadProgress === 'function' && onUploadProgress(progressEvent)
    }
  });
  return results.data;
}

export const Download = async (url) => {
  const results = await instance.get(url, {
    responseType: 'blob',
  });
  return results.data;
};
